import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { Z as doWhenDefaultIsNotPrevented } from './p-a57042e3.js';
import { h as hideElementFromAccessibilityAPI } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { d as defineCustomElement$4 } from './p-3a198e00.js';
import { d as defineCustomElement$3 } from './p-21c18302.js';
import { d as defineCustomElement$2 } from './p-9a56e546.js';
const fileUploaderItemCss = ".sc-owc-file-uploader-item-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;min-width:calc(var(--one-spacing-size-7-xs) * 252);padding:var(--one-spacing-padding-2-xs);-webkit-column-gap:var(--one-spacing-gap-4-xs);-moz-column-gap:var(--one-spacing-gap-4-xs);column-gap:var(--one-spacing-gap-4-xs);overflow:hidden;color:var(--one-color-interaction-active-intensity-higher);background-color:var(--one-color-interaction-default-base);border-radius:var(--one-spacing-radius-4-xs)}.sc-owc-file-uploader-item-h>.owc-file-uploader-item__bar-container.sc-owc-file-uploader-item{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;width:inherit}.sc-owc-file-uploader-item-h>.owc-file-uploader-item__prefix-container.sc-owc-file-uploader-item{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;gap:var(--one-spacing-gap-4-xs)}.sc-owc-file-uploader-item-h>.owc-file-uploader-item__prefix-container.sc-owc-file-uploader-item [slot=prefix].sc-owc-file-uploader-item{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;min-width:calc(var(--one-spacing-size-7-xs) * 118);max-width:calc(var(--one-spacing-size-7-xs) * 118);width:calc(var(--one-spacing-size-7-xs) * 118);color:inherit}.sc-owc-file-uploader-item-h>.owc-file-uploader-item__suffix-container.sc-owc-file-uploader-item{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;gap:var(--one-spacing-gap-4-xs)}.sc-owc-file-uploader-item-h>.owc-file-uploader-item__suffix-container.sc-owc-file-uploader-item [slot=suffix].sc-owc-file-uploader-item{min-width:calc(var(--one-spacing-size-7-xs) * 125);text-align:center;color:inherit}.owc-file-uploader-item--status-alarm.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled){background-color:var(--one-color-background-negative-low)}.owc-file-uploader-item--status-positive.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled){background-color:var(--one-color-interaction-active-subbrand-lower)}.owc-file-uploader-item--status-positive.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled) [slot=suffix].sc-owc-file-uploader-item{color:var(--one-color-interaction-active-subbrand-base)}.owc-file-uploader-item--disabled.sc-owc-file-uploader-item-h{color:var(--one-color-interaction-disabled-base)}.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--device-desktop){-ms-flex-wrap:wrap;flex-wrap:wrap;row-gap:var(--one-spacing-gap-4-xs)}.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--device-desktop)>.owc-file-uploader-item__prefix-container.sc-owc-file-uploader-item{-ms-flex-order:1;order:1;-ms-flex:0 1 auto;flex:0 1 auto;max-width:calc(100% - var(--one-spacing-size-7-xs) * 180);min-width:var(--one-spacing-size-5-xl);-webkit-box-sizing:border-box;box-sizing:border-box}.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--device-desktop)>.owc-file-uploader-item__prefix-container.sc-owc-file-uploader-item [slot=prefix].sc-owc-file-uploader-item{width:100%;max-width:100%;min-width:var(--one-spacing-size-none)}.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--device-desktop)>.owc-file-uploader-item__suffix-container.sc-owc-file-uploader-item{-ms-flex-order:2;order:2;-ms-flex:1 0 auto;flex:1 0 auto;-ms-flex-pack:end;justify-content:flex-end}.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--device-desktop)>.owc-file-uploader-item__bar-container.sc-owc-file-uploader-item{-ms-flex-order:3;order:3;-ms-flex-preferred-size:100%;flex-basis:100%;padding-right:var(--one-spacing-padding-l)}@media (forced-colors: active){.sc-owc-file-uploader-item-h -shadowcsshost{background-color:background}.owc-file-uploader-item--status-default.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled) .owc-progress-bar__container__bar.sc-owc-file-uploader-item{background-color:canvastext !important}.owc-file-uploader-item--status-alarm.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled) .owc-progress-bar__container.sc-owc-file-uploader-item{background-color:canvastext !important}.owc-file-uploader-item--status-positive.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled) .owc-progress-bar__container.sc-owc-file-uploader-item{background-color:canvastext !important}.owc-file-uploader-item--status-positive.sc-owc-file-uploader-item-h:not(.owc-file-uploader-item--disabled) .owc-progress-bar__container__bar.sc-owc-file-uploader-item{background-color:canvastext !important}.owc-file-uploader-item--disabled.sc-owc-file-uploader-item-h{color:graytext}.owc-file-uploader-item--disabled.sc-owc-file-uploader-item-h .owc-progress-bar__container__bar.sc-owc-file-uploader-item{background-color:background}}";
const OwcFileUploaderItemStyle0 = fileUploaderItemCss;
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const FileUploaderItem = /*@__PURE__*/proxyCustomElement(class FileUploaderItem extends H {
  constructor() {
    super();
    this.__registerHost();
    this.dismiss = createEvent(this, "dismiss", 3);
    this.prefixIconElement = useRef();
    this.dismissIconElement = useRef();
    this.component = new ComponentUtils(this);
    this.onDismissIconClick = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.dismiss.emit());
    };
    this.device = 'desktop';
    this.disabled = false;
    this.status = 'default';
    this.value = undefined;
    this.progressBarProps = undefined;
    this.prefixIconProps = undefined;
    this.dismissIconProps = undefined;
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`status-${this.status || 'default'}`]: true,
      [`device-${this.device || 'desktop'}`]: true,
      disabled: this.disabled
    });
    const barContainerClasses = this.component.getChildBemClasses('bar-container', hostClasses);
    const prefixContainerClasses = this.component.getChildBemClasses('prefix-container', hostClasses);
    const prefixIconElementClasses = this.component.getChildBemClasses('icon-element', prefixContainerClasses);
    const suffixContainerClasses = this.component.getChildBemClasses('suffix-container', hostClasses);
    const _a = this.dismissIconProps || {},
      {
        className: dismissIconClassName,
        onclick: originalOnDismissIconClick
      } = _a,
      dismissIconProps = __rest(_a, ["className", "onclick"]);
    return h(Host, {
      key: 'f3315d3a48b887f67713b0366a7a9f0bcc55b751',
      class: hostClasses
    }, h("div", {
      key: 'b86bf16c0624558dc7ff6eacb4bf93cd16d352a0',
      class: prefixContainerClasses
    }, h("owc-icon", Object.assign({
      key: '2b797615faaa6ce8e40f315bd951074f3752f35d'
    }, hideElementFromAccessibilityAPI(), {
      ref: this.prefixIconElement,
      name: "file",
      family: "filled",
      status: "inherit",
      class: prefixIconElementClasses,
      alt: ""
    }, this.prefixIconProps)), h("slot", {
      key: '9011e326834082eaa8697fbdf2258a0f0123d1a5',
      name: "prefix"
    })), h("div", {
      key: '6f5aee2fa14513c1315e7bb0f2d8f66b209e2e45',
      class: barContainerClasses
    }, h("owc-progress-bar", Object.assign({
      key: 'f1705f0419bf98782d8ba1951711ee850f1b4a59',
      mode: "determinate",
      value: this.value,
      status: this.status,
      disabled: this.disabled
    }, this.progressBarProps))), h("div", {
      key: 'e249e7859a21733aaaa0658031f6a357e652650b',
      class: suffixContainerClasses
    }, h("slot", {
      key: '3449ba1553d68ad185ae65b9afd37f11f6f31e5a',
      name: "suffix"
    }), h("owc-icon-button", Object.assign({
      key: 'c4fee72b97a0b90ca5d59282ea3932194797686b',
      ref: this.dismissIconElement,
      icon: "circle_clear",
      family: "outlined",
      alt: "clear",
      disableRipple: true,
      size: "xSmall",
      disabled: this.disabled
    }, dismissIconProps, {
      onClick: e => this.onDismissIconClick(e, originalOnDismissIconClick)
    }))));
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcFileUploaderItemStyle0;
  }
}, [6, "owc-file-uploader-item", {
  "device": [513],
  "disabled": [516],
  "status": [513],
  "value": [514],
  "progressBarProps": [16],
  "prefixIconProps": [16],
  "dismissIconProps": [16]
}]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-file-uploader-item", "owc-icon", "owc-icon-button", "owc-progress-bar"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-file-uploader-item":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, FileUploaderItem);
        }
        break;
      case "owc-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }
        break;
      case "owc-icon-button":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }
        break;
      case "owc-progress-bar":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }
        break;
    }
  });
}
const OwcFileUploaderItem = FileUploaderItem;
const defineCustomElement = defineCustomElement$1;
export { OwcFileUploaderItem, defineCustomElement };